<mat-form-field [appearance]="appearance!">
  <mat-label>{{ label }}</mat-label>
  <mat-datepicker-toggle matIconPrefix [for]="picker" *ngIf="dateOptions?.icon == 'prefix'"></mat-datepicker-toggle>
  <input
    matInput
    [matDatepicker]="picker"
    [formControlName]="name"
    (blur)="onBlur()"
    (input)="onChange($event)"
    [min]="dateOptions?.minDate"
    [max]="dateOptions?.maxDate" />
  <mat-datepicker-toggle matIconSuffix [for]="picker" *ngIf="dateOptions?.icon == 'suffix'"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>